<template>
    <modal-component
        :visible="visible"
        id="invoice-modal"
        :title="`${isInvoice ? 'Invoice' : 'Receipt'} #${invoice.id}`"
        size="lg"
        @close="$emit('close')"
    >
        <div id="invoicePrint" class="p-3">
            <div class="invoice-head d-flex justify-content-between align-items-start">
                <div class="center-info d-flex flex-column justify-content-start align-items-start">
                    <div class="center-logo" v-if="organization.logo_path">
                        <img
                            :src="organization.logo_path.replace('public', '/storage')"
                            class="img-fluid invoice-logo"
                        />
                    </div>
                    <div
                        class="center-address d-flex flex-column justify-content-start align-items-start"
                    >
                        <h5 class="mb-0 font-weight-bold">{{ organization.name }}</h5>
                        <h5 class="mb-0 font-weight-bold">{{ organization.address1 }}</h5>
                        <h5 class="mb-0 font-weight-bold">{{ organization.address2 }}</h5>
                        <h5 class="mb-0 font-weight-bold">
                            {{ organization.city }} {{ organization.state }} {{ organization.zip }}
                        </h5>
                        <h5 class="mb-0 font-weight-bold">{{ organization.primary_phone }}</h5>
                        <h5 v-if="false" class="mb-0 font-weight-bold">
                            Tax ID # {{ organization.tax_id_number }}
                        </h5>
                    </div>
                </div>
                <div
                    class="invoice-details d-flex flex-column justify-content-start align-items-start"
                >
                    <h3>Billing Claim Form</h3>
                    <table class="table table-bordered">
                        <tr>
                            <td class="p-1">Date</td>
                            <td class="p-1">Invoice #</td>
                        </tr>
                        <tr>
                            <td class="p-1">
                                {{
                                    invoice.created_at
                                        ? moment(invoice.created_at).format("MM/DD/YYYY")
                                        : ""
                                }}
                            </td>
                            <td class="p-1">{{ invoice.id }}</td>
                        </tr>
                    </table>

                    <div
                        class="invoice-responsible d-flex flex-column justify-content-start align-items-start w-100"
                    >
                        <table class="table table-bordered">
                            <tr>
                                <td class="p-1">
                                    <span>Responsible Party</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="p-1">
                                    <p class="mb-0" data-private="lipsum">
                                        {{
                                            helpers._get(
                                                invoice,
                                                "patient.responsible_party_contacts[0].name",
                                                ""
                                            )
                                        }}&nbsp;
                                    </p>
                                    <p class="mb-0">
                                        {{
                                            helpers._get(
                                                invoice,
                                                "patient.responsible_party_contacts[0].phone",
                                                ""
                                            )
                                        }}
                                    </p>
                                    <p class="mb-0">
                                        {{
                                            helpers._get(
                                                invoice,
                                                "patient.responsible_party_contacts[0].email",
                                                ""
                                            )
                                        }}
                                    </p>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <div
                class="invoice-body d-flex flex-column justify-content-between align-items-start mt-4"
            >
                <div class="table-first w-100">
                    <table class="table table-bordered mb-0">
                        <tr>
                            <td class="p-1">Service location</td>
                            <td class="p-1">Patient Name</td>
                            <td class="p-1">Diagnoses</td>
                        </tr>
                        <tr>
                            <td class="p-1">
                                <p class="mb-0">
                                    {{ helpers._get(invoice, "patient.addresses[0].address1", "") }}
                                </p>
                                <p class="mb-0">
                                    {{ helpers._get(invoice, "patient.addresses[0].address2", "") }}
                                </p>
                            </td>
                            <td class="p-1" data-private="lipsum">
                                {{ helpers._get(invoice, "patient.name", "") }}
                            </td>
                            <td class="p-1">
                                <span v-for="c in invoice.charges">
                                    <span v-for="d in c.diagnoses" class="comma-list"
                                        >{{ d.code }} - {{ d.service_nickname }}</span
                                    >
                                </span>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="table-content w-100">
                    <table class="table table-bordered mb-0">
                        <tr>
                            <td class="p-1">Billing code</td>
                            <td class="p-1">Services Provided</td>
                            <td
                                class="p-1"
                                v-if="invoice.can_submit_claim || invoice.has_submitted_claim"
                            >
                                Units
                            </td>
                            <td class="p-1">Service hrs.</td>
                            <td class="p-1">Date</td>
                            <td class="p-1">Amount</td>
                        </tr>
                        <tr v-for="c in invoice.charges">
                            <td class="p-1" v-if="c.preferred_cpt_code_id">
                                {{ getChargeCodeById(c.preferred_cpt_code_id).code }}
                            </td>
                            <td class="p-1" v-else>
                                <span v-for="code in c.codes" class="comma-list"
                                    >{{ code.code }}
                                </span>
                            </td>
                            <td class="p-1" v-if="c.preferred_cpt_code_id">
                                {{ getChargeCodeById(c.preferred_cpt_code_id).service_nickname }}
                            </td>
                            <td class="p-1" v-else>
                                <span v-for="code in c.codes" class="comma-list"
                                    >{{ code.service_nickname }}
                                </span>
                            </td>
                            <td
                                class="p-1"
                                v-if="invoice.can_submit_claim || invoice.has_submitted_claim"
                            >
                                {{ c.unit_count }}
                            </td>
                            <td class="p-1">{{ c.service_hours }}</td>
                            <td class="p-1">
                                {{
                                    c.service_start_at
                                        ? moment(c.service_start_at).format("MM/DD/YYYY")
                                        : ""
                                }}
                            </td>
                            <td class="p-1">
                                {{
                                    c.expected_amount ? `$${c.expected_amount.toFixed(2)}` : `$0.00`
                                }}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <div class="invoice-footer d-flex justify-content-between align-items-start">
                <div
                    class="flex-grow-1 therapist-information d-flex flex-column justify-content-start align-items-start"
                >
                    <table class="table table-bordered">
                        <tr>
                            <td class="p-1">
                                <span>Therapist Information</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="p-1">
                                <span>{{ helpers._get(invoice, "therapists[0].name", "") }}</span
                                >&nbsp;
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="flex-grow-1"></div>
                <div
                    class="flex-grow-1 total-breakdown d-flex flex-column justify-content-start align-items-start"
                >
                    <table class="table table-bordered">
                        <tr>
                            <td class="p-1 d-flex justify-content-between">
                                <span class="font-weight-bold">Total</span>
                                <span>${{ getInvoiceSum() }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="p-1">
                                <div class="d-flex justify-content-between">
                                    <span class="font-weight-bold">Payments/credits</span>
                                    <span>${{ getTotalPayments() }}</span>
                                </div>
                                <span class="small font-italic">
                                    Payment method: {{ paymentMethod }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="p-1 d-flex justify-content-between">
                                <span class="font-weight-bold">Balance Due</span>
                                <span class="font-weight-bold">${{ getInvoiceBalance() }}</span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <div v-if="!isInvoice && invoice.expected_amount === this.invoice.paid_amount">
                <pre class="text-uppercase invoice-paid">** Invoice paid **</pre>
            </div>
        </div>

        <div class="d-flex w-100 justify-content-end">
            <button class="btn btn-sm btn-primary" @click="helpers.printElement('invoicePrint')">
                Print
            </button>
        </div>
    </modal-component>
</template>

<script>
import ModalComponent from "../ui/ModalComponent";
import { helpers } from "../../plugins/helpers";

export default {
    name: "Invoice",
    props: ["organization", "invoice", "isInvoice"],
    components: { ModalComponent },
    data() {
        return {
            helpers,
            visible: false,
            codes: [],
        };
    },
    watch: {
        visible() {
            if (_.get(this.organization, "id", false)) {
                this.getCodes();
            }
        },
    },
    computed: {
        paymentMethod() {
            if (_.get(this.invoice, "payment_type", false)) {
                switch (this.invoice.payment_type) {
                    case "cc":
                        return "Credit card";
                    case "cof":
                        return `Credit card on file (${this.invoice.patient.card_brand} ending in ${
                            this.invoice.patient.card_last_four
                        })`;
                    case "check":
                        return "Check";
                    case "cash":
                        return "Cash";
                    case "prepayment":
                        return "Prepayment";
                }
            }
        },
    },

    methods: {
        getCodes() {
            axios
                .get(`/api/organizations/${this.$root.organization.id}/cpt_codes`)
                .then(response => {
                    this.codes.push(...response.data.data);
                });
            axios
                .get(`/api/organizations/${this.$root.organization.id}/service_codes`)
                .then(response => {
                    this.codes.push(...response.data.data);
                });
        },

        getChargeCodeById(id) {
            return this.codes.find(code => code.id === id) || {};
        },

        getInvoiceSum() {
            return this.invoice.expected_amount >= 0
                ? this.invoice.expected_amount.toFixed(2)
                : `0.00`;
        },

        getTotalPayments() {
            return this.invoice.paid_amount >= 0 ? this.invoice.paid_amount.toFixed(2) : `0.00`;
        },

        getInvoiceBalance() {
            return this.invoice.paid_amount >= 0 && this.invoice.expected_amount >= 0
                ? (this.invoice.expected_amount - this.invoice.paid_amount).toFixed(2)
                : `0.00`;
        },
    },
};
</script>

<style scoped>
.invoice-logo {
    height: 1in;
}
.invoice-paid {
    font-size: 1.25rem;
}
</style>
